export default __webpack_public_path__ + "static/media/landing-page-4.05056901.jpg";